module.exports = __webpack_public_path__ + "fonts/Roboto-700-symbols54.8feefe1.woff2";